module.exports = __webpack_public_path__ + "static/media/index.e0c6f5ad.cjs";